    <template>
      <div class="account-section">


          <div class="account-unverified">
            <img class="section-top" src="@/assets/imgs/act/wc2026/section-top.png" alt="section-title-icon">
            <img class="login-icon" :src="title" />
            <div class="account-info-wrap flex-center" v-if="actUserInfo.token">
              <div>
                <div class="account-id-wrap flex-center">
                 
                  <img class="account-id-icon" src="@/assets/imgs/act/wc2026/login/account-id-icon.png" alt="account-id-icon">
                  <div class="label">{{ $t('wc2026.accountId') }}</div>
                  <div class="account-split-line"></div>
                  <div class="val">{{ actUserInfo.uid }}</div>
                </div>
                <div class="account-nickname-wrap flex-center">
                  <img class="account-nickname-icon" src="@/assets/imgs/act/wc2026/login/account-nickname-icon.png" alt="account-nickname-icon">
                  <div class="label">{{ $t('wc2026.rank.nickname') }}</div>
                  <div class="account-split-line"></div>
                  <div class="val">{{ actUserInfo.roleName }}</div>
                </div>

                <div class="logout-btn-wrap flex-center btn" @click="handleLogout">
                  <img class="logout-btn-icon" src="@/assets/imgs/act/wc2026/login/resetIcon.png" alt="logout-btn-icon">
                  <div class="logout-btn-text">{{ $t('wc2026.logout') }}</div>
                </div>
             </div>
  
            </div>
            <div v-else >
           
            <div class="verify-btn flex-center btn" @click="state.showLoginDialog = true">
              {{ $t('wc2026.login.logintxt') }}
            </div>
            </div>
          </div>

        <LoginDialog
        v-model="state.showLoginDialog"
        @loginSuccess="onLoginSuccess"
      />
      </div>
    </template>
    <script setup>
    import { reactive, computed } from 'vue'
    import loginEn from '@/assets/imgs/act/wc2026/login/titleEn.png'
    import LoginDialog from '../LoginDialog/index.vue'
    import loginZh from '@/assets/imgs/act/wc2026/login/titlezh.png'
    import loginVi from '@/assets/imgs/act/wc2026/login/titlevi.png'
    import loginTh from '@/assets/imgs/act/wc2026/login/titleth.png'
    import loginId from '@/assets/imgs/act/wc2026/login/titleid.png'
    import { useI18n } from 'vue-i18n'
    import { useStore } from 'vuex'
    import { useLog } from '@/composables/useActLog'
    const log = useLog()
    const store = useStore()
    const actUserInfo = computed(() => store.state.actUserInfo)
    const locale = useI18n().locale
    const title = computed(() => {

      switch (locale.value) {
        case 'en':
          return loginEn
        case 'tw':
          return loginZh
        case 'vi':
          return loginVi
        case 'th':
          return loginTh
        case 'id':
          return loginId
        case 'hk':
          return loginZh
        default:
          return loginEn
      }
    })
    const state = reactive({
      isLoggedIn: false,
      cpUserInfo: {},
      availableCheerCount: 0,
      actInfo: {},
      showLoginDialog: false,
    })


    const onLoginSuccess = () => {
      log.track('act_worldcup_login')
      state.isLoggedIn = true
    }
    const handleLogout = () => {
      store.commit('SET_ACT_USER_INFO', {})
    }


    </script>
    <style lang="less" scoped>
  
  .login-icon {
    height: 72px;
    width: auto;
    display: block;
    margin: auto;
  }
  .verify-btn {
    width: 170px;
    height: 58px;
    background-image:url("~@/assets/imgs/act/wc2026/login/verify-btn.png");
    margin: 20px auto;
    font-weight: bold;
    font-size: 23px;
    color: #fff;
    text-align: center;
    line-height: 55px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .account-verified {
    padding: 30px;
    font-size: 30px;
  }
  .account-info-wrap {
    position: relative;
    margin: 14px auto;
    width: 613px;
    height: 121px;
    margin-bottom: 14px;
    background-image: url("~@/assets/imgs/act/wc2026/login/Rectangle.png");
    .account-split-line {
      width: 2px;
      height: 20px;
      background-color: #1B0926;
    }
    .label {
     width: 120px;
    }
    .val {
      width: 120px;
    }

    .account-id-wrap {
      gap: 20px;
      margin-bottom: 15px;
      .account-id-icon {
        width: 30px;
        height: 31px;
        background-image: url("~@/assets/imgs/act/wc2026/login/account-id-icon.png");
      }
     
    }
    .account-nickname-wrap {
      gap: 20px;
      .account-nickname-icon {
        width: 30px;
        height: 31px;
        background-image: url("~@/assets/imgs/act/wc2026/login/account-nickname-icon.png");
      }

    }
    .logout-btn-wrap {
      width: 127px;
      height: 45px;
      gap: 3px;
      font-size: 17px;
      position: absolute;
      right: -17px;
      bottom: -4px;
      cursor: pointer;
      color: #fff;
      background-image: url("~@/assets/imgs/act/wc2026/login/resetBtn.png");
      .logout-btn-icon {
        width: 25px;
        height: 15px;
      }
    }
}
  </style>